const eventCategory = "DIY_N_Price";

export const docUploadCommon = {
    eventCategory: "DIY_doc_upload"
};

export const aadharVerifyClicked = {
    eventCategory,
    eventAction: "Aadhar verify button clicked "
};
export const panVerifyClicked = {
    eventCategory,
    eventAction: "Pan verify button clicked "
};
